import script from "./levelView.vue?vue&type=script&setup=true&lang=ts"
export * from "./levelView.vue?vue&type=script&setup=true&lang=ts"

import "./levelView.vue?vue&type=style&index=0&id=3ff32651&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff32651"]])

export default __exports__